import $ from 'jquery'
import each from 'lodash/each'

const $addresses = $('[data-address-autocomplete]')

$addresses.each(function autocompleteAddress() {
  if (typeof google === 'undefined' || !google.maps || !google.maps.places || !google.maps.places.Autocomplete) {
    return
  }

  const $container = $(this)
  const $street = $container.find('input[data-field="street"]')
  const $city = $container.find('input[data-field="city"]')
  const $state = $container.find('input[data-field="state"]')
  const $zip = $container.find('[data-field="zip"]')

  const autocomplete = new google.maps.places.Autocomplete($street[0], {
    componentRestrictions: { country: 'us' },
  })

  autocomplete.addListener('place_changed', () => {
    let streetNum = null
    let address = null
    let city = null
    let state = null
    let zip = null

    const place = autocomplete.getPlace()
    each(place.address_components, (data) => {
      const addressType = data.types[0]

      switch (addressType) {
        case 'street_number':
          streetNum = data.short_name
          break
        case 'route':
          address = data.short_name
          break
        case 'locality':
          city = data.short_name
          break
        case 'administrative_area_level_1':
          state = data.short_name
          break
        case 'postal_code':
          zip = data.short_name
          break
        default:
          break
      }
    })

    $street.val(`${streetNum} ${address}`)
    $city.val(city)
    $state.val(state)
    $zip.val(zip)

    $container.trigger('place_changed', {
      place,
      address: `${streetNum} ${address}`,
      city,
      state,
      zip,
      lat: place.geometry.location.lat(),
      lng: place.geometry.location.lng(),
    })
  })
})
